<button class="icon-left" mat-icon-button [matMenuTriggerFor]="boolFilterMenu" aria-label="Filter">
    <mat-icon [ngClass]="{'material-icons-outlined' : !hasFilterSelected()}">filter_alt</mat-icon>
</button>
<mat-menu #boolFilterMenu="matMenu">
    <div class="boolFilterMenu" (click)="$event.stopPropagation()">
        <div>
            <button class="clear-button" mat-icon-button (click)="clearFilters()">
                <div class="icon-container">
                    <mat-icon>block</mat-icon>
                </div>
                <span class="text-container">Clear filter</span>
            </button>
        </div>
        <div class="small-margin-left medium-margin-top">
            <div><mat-checkbox color="primary" [(ngModel)]="filter.yes" (change)="invokeSelectionChanged()">&nbsp; Yes</mat-checkbox></div>
        </div>
        <div class="small-margin-left medium-margin-top">
            <div><mat-checkbox color="primary" [(ngModel)]="filter.no" (change)="invokeSelectionChanged()">&nbsp; No</mat-checkbox></div>
        </div>
    </div>
</mat-menu>